import { Button, Tooltip } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUserRoles } from "redux/slices/userSlice";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";
import { useIsAssignedToJob } from "features/candidates/hooks/useIsAssignedToJob";
import TransferCandidateModal from "./transferCandidateModal";

export default function TransferCandidateButton({
  candidateActivity,
  jobDetails,
  clientId,
  disabled,
  onSuccess,
}) {
  const userRoles = useSelector(selectUserRoles);
  const isAssignedToSourceJob = useIsAssignedToJob(jobDetails);

  const canTransfer =
    isPermissionPresent(K.Permissions.TransferCandidate, userRoles) &&
    isAssignedToSourceJob;

  const [transferCandidate, setTransferCandidate] = useState({
    showModal: false,
    transferResponse: null,
  });

  const handleTransferCandidate = () => {
    setTransferCandidate((prev) => ({ ...prev, showModal: true }));
  };

  if (!canTransfer) return null;

  return (
    <>
      <Tooltip title="Transfer">
        <Button
          type="link"
          disabled={disabled}
          icon={<SwapOutlined />}
          onClick={handleTransferCandidate}
        />
      </Tooltip>

      <TransferCandidateModal
        candidateActivity={candidateActivity}
        transferCandidate={transferCandidate}
        setTransferCandidate={setTransferCandidate}
        jobId={jobDetails.id}
        clientId={clientId}
        onSuccess={onSuccess}
      />
    </>
  );
}
